import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';

@Component({
  selector: 'app-footer-type06',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink],
  templateUrl: './footer-type06.component.html',
  styleUrl: './footer-type06.component.scss'
})
export class FooterType06Component implements OnInit {

  public view: any = {
    showAllDestinations: false
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef) {

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      // console.log(res);

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });

    this._tfmService.getPages().then((res: any) => {
      this.view.pages = res.content.filter(x => !(x.section === 'about' || x.section === 'contact' || x.section === 'travel' || x.section === 'corporate-travel' || x.section === 'leisure-travel' || x.section === 'xl-howzit-promo' || x.section === 'team' || x.section === 'specials'));
      // this.view.pages = res;
      // this._tfmService.log(res);
    });

    this._tfmService.getSiteLayoutOptions().subscribe(res => {
      this.view.layoutOptions = res;
      // this._tfmService.log(res);
    });

    this._tfmService.getDestinations().then(res => {
      this.view.destinations = res;
      this._tfmService.log("Destinations:", this.view.destinations)
    });
  }

  limitedDestinations(): any[] {
    if (!this.view?.destinations) return [];
    return this.view.showAllDestinations
      ? this.view.destinations
      : this.view.destinations.slice(0, 3);
  }

  hasMoreDestinations(): boolean {
    return this.view?.destinations;
  }

  get currentYear(): number {
    return new Date().getFullYear();
  };

  ngOnInit(): void {
  }
}
